import type { Element, Root } from "hast";
import { createElement } from "react";
import type { Plugin } from "unified";
import { Test, visit } from "unist-util-visit";
import { WidgetLoader as WLComponent } from "./WidgetLoader.tsx";
import { WidgetId, WidgetType } from "./WidgetContext.tsx";

interface Options {
  WidgetLoader?: typeof WLComponent;
}

const check: Test = (node) => {
  return node.type === "widget";
};

export const widgetRehypePlugin: Plugin<[Options], Root> = (options) => {
  return (tree) => {
    visit(tree, check, (node) => {
      node.type = "element";
      const element: Element = node as unknown as Element;
      element.tagName = "span";
      element.properties = {};

      const widgetNode = node as unknown as {
        widgetType: string;
        widgetId?: WidgetId;
        widgetIds?: WidgetId[];
      };

      // Determine props based on widget type
      const loaderProps =
        widgetNode.widgetType === "citation-group" && widgetNode.widgetIds
          ? {
              widgetIds: widgetNode.widgetIds,
              widgetType: "citation-group" as const,
            }
          : {
              widgetId: widgetNode.widgetId,
              widgetType: widgetNode.widgetType as WidgetType,
            };

      element.children = [
        {
          type: "raw",
          value: createElement(
            options?.WidgetLoader || WLComponent,
            loaderProps,
          ) as unknown as string,
        },
      ];
    });
  };
};
